import React, { useEffect } from 'react'
import { Card, TextField, CardContent, Button, FormControl, Grid, MenuItem } from '@mui/material';

import { LinearLoading, CustomAutocomplete, CustomLoading } from 'common'

export const FormTransactionCashier = ({ useFetchInit }) => {

    const {
        globalStates,
        Forms,
        FetchData,
        Actions
    } = useFetchInit

    const { modalOpeningMode, loadingSubmitForm } = globalStates

    const { FormScreen } = Forms
    const { formState, onInputChange, onSelectSearchChange } = FormScreen
    
    const { fetchSpecificTransactionCashier, fetchCategories, fetchCashierByCategory } = FetchData
    const { dataCategories, loadingFetchCategories } = fetchCategories
    const { loadingFetchSpecificTransactionCashier } = fetchSpecificTransactionCashier
    const { dataCashRegisters } = fetchCashierByCategory

    const {
        onSubmitForm,
        handleChangeAmount,
        handleChangeTypeCurrency,
        handleChangeExchangeRate,
        handleClickHideForm
    } = Actions

    useEffect(() => {
            
        fetchCashierByCategory.setParamsToSearch({
            idcategoria: formState.idcategoria,
            currency_type: formState.movimiento_moneda
        })
        fetchCashierByCategory.executeFetch()

    }, [formState.idcategoria, formState.movimiento_moneda])

    return (
        <div className='content'>
            <Card style={{zIndex:'1'}}>
                <CardContent>
                    <div className='h4 mt-1 mb-1'>
                        {formState.idmovimiento > 0
                            ? 'Informacion de Registro'
                            : 'Crear Registro'}
                    </div>
                    <div className="border-bottom border-dark"></div>
                    {loadingFetchSpecificTransactionCashier && ( <LinearLoading /> )}

                    <div className="pt-3"></div>
                    <p className='text-danger'>* campos obligatorios</p>
                    <div className="pt-2"></div>

                    <form onSubmit={onSubmitForm}>
                        <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                            <Grid item xs={12} sm={6} md={4} lg={4}>
                                <FormControl fullWidth>
                                    <label htmlFor="movimiento_fecha">* Fecha de registro</label>
                                    <TextField
                                        id='movimiento_fecha'
                                        name='movimiento_fecha'
                                        value={ formState.movimiento_fecha }
                                        onChange={ onInputChange }
                                        size='small'
                                        placeholder='Fecha de registro'
                                        type='date'
                                        variant='filled'
                                        hiddenLabel
                                        InputProps={{
                                            readOnly: true
                                        }}
                                        required
                                    />
                                </FormControl>
                            </Grid>
                        </Grid>
                        <div className="pt-4"></div>
                        <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                            <Grid item xs={12} sm={6} md={4} lg={4}>
                                <FormControl fullWidth>
                                    <label htmlFor="movimiento_tipo">* Tipo</label>
                                    <TextField
                                        id="movimiento_tipo"
                                        name="movimiento_tipo"
                                        value={formState.movimiento_tipo}
                                        onChange={onInputChange}
                                        select
                                        size="small"
                                        variant={(modalOpeningMode==='READONLY')? 'filled':'outlined'}
                                        hiddenLabel
                                        InputProps={{
                                            readOnly: (modalOpeningMode==='READONLY') 
                                        }}
                                        required
                                    >
                                        <MenuItem value='INGRESO'>INGRESO</MenuItem>
                                        <MenuItem value='EGRESO'>EGRESO</MenuItem>
                                    </TextField>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4} lg={4}>
                                <FormControl fullWidth>
                                    <label htmlFor="idcategoria">* Categoría</label>
                                    {(loadingFetchCategories)&&(<LinearLoading/>)}
                                    <CustomAutocomplete 
                                        customId="idcategoria"
                                        customName="idcategoria"
                                        customValue={formState.idcategoria}
                                        customOnChange={(target, value) => onSelectSearchChange({ target: { name: 'idcategoria', value: value.value }})}
                                        customPlaceholder='Seleccionar opción'
                                        customOptions={
                                            dataCategories.map(({ idcategoria, nombre }) => ({
                                                value: idcategoria,
                                                name: nombre
                                            }))
                                        }
                                        customDisableClearable={true}
                                        customDisabled={(modalOpeningMode==='READONLY')}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4} lg={4}>
                                <FormControl fullWidth>
                                    <label htmlFor="movimiento_moneda">* Moneda</label>
                                    <TextField
                                        id="movimiento_moneda"
                                        name="movimiento_moneda"
                                        // label="Moneda"
                                        value={formState.movimiento_moneda}
                                        onChange={handleChangeTypeCurrency}
                                        select
                                        size="small"
                                        variant={(modalOpeningMode==='READONLY')? 'filled':'outlined'}
                                        // lable="Selecciona una opción"
                                        hiddenLabel
                                        InputProps={{ 
                                            readOnly: (modalOpeningMode==='READONLY')
                                        }}
                                    >
                                        <MenuItem value='QUETZAL'>QUETZAL</MenuItem>
                                        <MenuItem value='DOLAR'>DOLAR</MenuItem>
                                    </TextField>
                                </FormControl>
                            </Grid>
                            </Grid>
                        <div className="pt-2"></div>
                        <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                            <Grid item xs={12} sm={6} md={4} lg={4}>
                                 <FormControl fullWidth>
                                        <label htmlFor="idcaja">* Caja</label>
                                        <CustomAutocomplete 
                                            customId="idcaja"
                                            customName="idcaja"
                                            customValue={formState.idcaja}
                                            customOnChange={(target, value) => onSelectSearchChange({ target: { name: 'idcaja', value: value.value }})}
                                            customPlaceholder='Seleccionar caja'
                                            customOptions={
                                                dataCashRegisters.map(({ idcaja, descripcion_corta }) => ({
                                                    value: idcaja,
                                                    name: descripcion_corta
                                                }))
                                            }
                                            customDisableClearable={true}
                                            customDisabled={(modalOpeningMode==='READONLY')}
                                        />
                                    </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4} lg={4}>
                                <FormControl fullWidth>
                                    <label htmlFor="movimiento_monto">* Monto</label>
                                    <TextField
                                        id="movimiento_monto"
                                        name="movimiento_monto"
                                        value={formState.movimiento_monto}
                                        onChange={handleChangeAmount}
                                        // label='Monto a recibir' 
                                        size='small'
                                        type="text"
                                        min="0"
                                        step="0.01"
                                        variant={(modalOpeningMode==='READONLY')? 'filled':'outlined'}
                                        hiddenLabel
                                        InputProps={{ 
                                            readOnly: (modalOpeningMode==='READONLY')
                                        }}
                                        required
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4} lg={4}>
                                <FormControl fullWidth>
                                    <label htmlFor="movimiento_tipo_cambio">* Tipo de Cambio</label>
                                    <TextField
                                        id="movimiento_tipo_cambio"
                                        name="movimiento_tipo_cambio"
                                        value={formState.movimiento_tipo_cambio}
                                        onChange={handleChangeExchangeRate}
                                        // label='Tipo de cambio'
                                        size='small'
                                        type="text"
                                        min="0"
                                        step="0.01"
                                        variant={(modalOpeningMode==='READONLY')? 'filled':'outlined'}
                                        hiddenLabel
                                        InputProps={{ 
                                            readOnly: (modalOpeningMode==='READONLY')
                                        }}
                                        required
                                    />
                                </FormControl>
                            </Grid>
                        </Grid>
                        <div className="pt-2"></div>
                        <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                            <Grid item xs={12} sm={6} md={6} lg={6}>
                                <FormControl fullWidth>
                                    <label htmlFor="movimiento_quetzales">* Total en Quetzales</label>
                                    <TextField
                                        id="movimiento_quetzales"
                                        name="movimiento_quetzales"
                                        value={formState.movimiento_quetzales}
                                        onChange={onInputChange}
                                        // label='Total en quetzales'
                                        size='small'
                                        type="text"
                                        min="0"
                                        step="0.01"
                                        variant='filled'
                                        hiddenLabel
                                        InputProps={{ 
                                            readOnly: true
                                        }}
                                        required
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6} md={6} lg={6}>
                                <FormControl fullWidth>
                                    <label htmlFor="movimiento_dolares">* Total en Dolares</label>
                                    <TextField
                                        id="movimiento_dolares"
                                        name="movimiento_dolares"
                                        value={formState.movimiento_dolares}
                                        onChange={onInputChange}
                                        // label='Total en dolares'
                                        size='small'
                                        type="text"
                                        min="0"
                                        step="0.01"
                                        variant='filled'
                                        hiddenLabel
                                        InputProps={{ 
                                            readOnly: true
                                        }}
                                        required
                                    />
                                </FormControl>
                            </Grid>
                        </Grid>
                        <div className="pt-2"></div>
                        <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                <FormControl fullWidth>
                                    <label htmlFor="movimiento_observaciones"> * Observaciones</label>
                                    <TextField
                                        id="movimiento_observaciones"
                                        name="movimiento_observaciones"
                                        // label="Observaciones"
                                        value={formState.movimiento_observaciones}
                                        onChange={onInputChange}
                                        size='small'
                                        multiline
                                        rows={3}
                                        type="text"
                                        variant={(modalOpeningMode==='READONLY')? 'filled':'outlined'}
                                        InputProps={{
                                            readOnly: (modalOpeningMode==='READONLY')
                                        }}
                                    />
                                </FormControl>
                            </Grid>
                        </Grid>

                        <div className="pt-4"></div>
                        {(loadingSubmitForm)&&(<CustomLoading/>)}
                        <Grid container>
                            <Grid item>
                                <div className='update ml-auto mr-auto'>
                                    <Button
                                        style={{background: "#4b4b4c"}}
                                        variant="contained"
                                        type='submit'
                                        disabled={(modalOpeningMode==='READONLY') || loadingSubmitForm}
                                    >
                                        <i className="fa-regular fa-floppy-disk"></i> &nbsp; Guardar
                                    </Button>
                                    &nbsp; &nbsp;
                                    <Button
                                        style={{ marginRight: 2, marginLeft: 2, background: "#ef8157" }}
                                        type='button'
                                        variant="contained"
                                        onClick={handleClickHideForm}
                                        disabled={loadingSubmitForm}
                                    >
                                        <i className="fa-regular fa-circle-left"></i> &nbsp; Cancelar
                                    </Button>
                                </div>
                            </Grid>
                        </Grid>
                    </form>
                </CardContent>
            </Card>
        </div>
    )
}
